/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 3,
    spaceBetween: 32,
    breakpoints: {
      // when window width is <= 768px (tablet & mobile)
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 769px (desktop)
      769: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: ".custom-next",
      prevEl: ".custom-prev",
    },
  });

   window.addEventListener('scroll', function(e) {
    e.preventDefault();

      // console.log("e Target",e.target);
      const header = document.querySelector('.header__wrapper'); 
      const headerHeight = document.querySelector('header').offsetHeight;
      const banners = document.querySelectorAll('.hero__wrapper'); 

     
      
      let isTransparent = false;  
      let lastBannerIndex = banners.length - 1;  

      // Loop through all the banners
      banners.forEach(function(banner, index) {
          const bannerBottom = banner.getBoundingClientRect().bottom;
          const bannerTop = banner.getBoundingClientRect().top;
          
          const previousBanner = banners[index - 1]; 
          const previousBannerBottom = previousBanner ? previousBanner.getBoundingClientRect().bottom : null;

          if (previousBannerBottom <= headerHeight && bannerTop > 0) {
              isTransparent = false; 
          }


          if (bannerTop <= headerHeight) {
              isTransparent = true;  
          }

          if (index === lastBannerIndex && bannerBottom <= headerHeight) {
              isTransparent = false; 
          }
      });

      if (isTransparent) {
          header.classList.add('transparent');
          header.classList.remove('js__header__stuck');
          document.body.classList.add(".has-first-section-overlay-header");
      } else {
          header.classList.remove('transparent');
          header.classList.add('js__header__stuck');
          document.body.classList.remove(".has-first-section-overlay-header");
      }
  });
});


